import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';

export interface LoyaltyPeriodDto {
  id: string;
  name: string;
  startsAt: string;
  endsAt: string;
}

export interface LoyaltyPeriodInput {
  name: string;
  startsAt: string;
  endsAt: string;
}

const QK = { list: ['loyalty-periods'] as const };

export function useLoyaltyPeriods() {
  return useQuery({
    queryKey: QK.list,
    queryFn: async () => {
      const res = await apiClient.get<LoyaltyPeriodDto[]>('/loyalty-periods');
      return res.data;
    },
  });
}

export function useCreateLoyaltyPeriod() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: LoyaltyPeriodInput) => {
      const res = await apiClient.post<LoyaltyPeriodDto>('/loyalty-periods', input);
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK.list }),
  });
}

export function useUpdateLoyaltyPeriod() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, input }: { id: string; input: Partial<LoyaltyPeriodInput> }) => {
      const res = await apiClient.patch<LoyaltyPeriodDto>(`/loyalty-periods/${id}`, input);
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK.list }),
  });
}

export function useDeleteLoyaltyPeriod() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.delete(`/loyalty-periods/${id}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK.list }),
  });
}
